import { Card, Col, Container, Row } from 'reactstrap'
import { MasonryGalleryCap } from '../../../../Utils/Constants'
import MasonryGalleryBody from './MasonryGalleryBody'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const MasonryGalleryContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12" className="box-col-12">
          <Card className="pb-5">
            <CardHeaderCommon title={MasonryGalleryCap} />
            <MasonryGalleryBody />
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default MasonryGalleryContainer